import React from 'react';
import {HandySvg} from "handy-svg";
import reloadSVG from "../../header/img/reload.svg";
import "./StyleReload.css"

const Reload = ({
                    classModificator,
                    classModificatorDecktop,
                    textModificatorReload,
                    hasUnsavedChanges,
                    onConfirmReload
                }) => {
    const width = window.innerWidth;
    let modificator;

    if (width <=1280){
        modificator = classModificator
    }else if (width >=800){
        modificator = classModificatorDecktop
    }else{
        modificator = ""
    }

    const handleReload = async () => {
        // Если есть несохраненные изменения и передан обработчик подтверждения
        if (hasUnsavedChanges && onConfirmReload) {
            const confirmed = await onConfirmReload();
            if (confirmed) {
                window.location.reload();
            }
        } else {
            // Если нет изменений или нет обработчика, обновляем сразу
            window.location.reload();
        }
    };

    return (
        <div className={`${modificator} ButReload`} onClick={handleReload}>
            <div className={`TextButReload ${textModificatorReload}`}>Обновить страницу</div>
            <HandySvg src={reloadSVG} className="logout reloadSvg"/>
        </div>
    );
};

export default Reload;